// THEME FILES
// -----------------------------------------------------------------------------

// VENDOR FILES
// -----------------------------------------------------------------------------
import '../../source/vendor/bootstrap-5.3.8/dist/js/bootstrap.bundle.min.js';

// CUSTOM CODE
// -----------------------------------------------------------------------------


// this function is from user-functions.js

// Get the user_type from the query params or localStorage
function getUserType() {
    const urlParams = new URLSearchParams(window.location.search);
    let userType = urlParams.get('user_type');
    // check if the user_type is in the localStorage
    if (!userType) {
        userType = getLocalStorageDataKey('userData', 'user_type'); // eslint-disable-line no-undef
    }
    return userType;
}

// Get the operator_id from the query params or localStorage
function getOperatorId() {
    const urlParams = new URLSearchParams(window.location.search);
    let operatorId = urlParams.get('operator_id');
    // check if the operator_id is in the localStorage
    if (!operatorId) {
        operatorId = getLocalStorageDataKey('userData', 'id'); // eslint-disable-line no-undef
    }
    return operatorId;
}

//Creates previous/next buttons in Tabs block
document.addEventListener('DOMContentLoaded', function (e) {
    // Select all tab containers
    const tabContainers = document.querySelectorAll('.container-tabs-vertical');
    if (tabContainers) {
        tabContainers.forEach((tabContainer) => {
            const tabsWrapper = tabContainer.querySelector(
                '.wp-block-pacecore-blocks-tabs'
            );
            if (!tabsWrapper) return;

            // Retrieve Previous and Next URLs from data attributes
            const prevUrl = tabContainer.dataset.previousUrl;
            const nextUrl = tabContainer.dataset.nextUrl;
            const nextLabel = tabContainer.dataset.nextLabel;
            const prevLabel = tabContainer.dataset.previousLabel;

            // Create Previous Button
            const prevButton = document.createElement('button');
            prevButton.className = 'tab-button prev-tab';
            prevButton.textContent = 'Previous';
            prevButton.defaultText = 'Previous';
            prevButton.setAttribute('aria-label', 'Go to previous tab');
            prevButton.dataset.originalHref = prevUrl;
            prevButton.type = 'button';

            // Create Next Button
            const nextButton = document.createElement('button');
            nextButton.className = 'tab-button next-tab';
            nextButton.textContent = 'Next';
            nextButton.defaultText = 'Next';
            nextButton.setAttribute('aria-label', 'Go to next tab');
            nextButton.dataset.originalHref = nextUrl;
            nextButton.type = 'button';

            // Check if the window path contains /forms/ and add a 'Save for Later' button
            const saveButton = document.createElement('button');
            saveButton.id = 'save-for-later';
            saveButton.className = 'tab-button next-tab';
            saveButton.textContent = 'Save for Later';
            saveButton.defaultText = 'Save for Later';
            saveButton.setAttribute('aria-label', 'Save form for later');
            saveButton.dataset.originalHref = '#';
            saveButton.type = 'button';

            // Create a wrapper for the buttons
            const buttonWrapper = document.createElement('div');
            buttonWrapper.className = 'tab-navigation-buttons';
            buttonWrapper.setAttribute('role', 'group');
            buttonWrapper.setAttribute('aria-label', 'Tab step controls');
            buttonWrapper.style.marginTop = '1rem';
            buttonWrapper.style.display = 'flex';

            // Append buttons inside the wrapper
            buttonWrapper.appendChild(prevButton);
            buttonWrapper.appendChild(nextButton);

            if (window.location.pathname.includes('/forms/')) {
                // Append the button after the tab buttons
                buttonWrapper.appendChild(saveButton);
            }

            const navigationColumn = document.createElement('div');
            navigationColumn.className = 'tab-navigation-column';
            tabsWrapper.before(navigationColumn);
            navigationColumn.appendChild(tabsWrapper);
            navigationColumn.appendChild(buttonWrapper);

            const tabs = Array.from(
                tabsWrapper.querySelectorAll('.nav-link')
            ).filter((tab) => {
                // The Print Completed Form tab is a post-submission destination,
                // not an application step. Keep it out of the Previous/Next
                // sequence so correcting validation errors cannot accidentally
                // advance an applicant to the completed-form screen.
                return (
                    tab.offsetParent !== null &&
                    tab.id !== 'form-submitted-now-print-tab'
                );
            });

            if (tabs.length === 0) return;

            function updateButtonLinks() {
                const activeTab = tabsWrapper.querySelector('.nav-link.active');
                if (!activeTab) return;

                const activeIndex = tabs.indexOf(activeTab);
                const firstTab = tabs[0];
                const lastTab = tabs[tabs.length - 1];

                // Link Button if the first tab is active, advance tabs if not
                if (activeTab === firstTab) {
                    prevButton.textContent = prevLabel;
                    prevButton.onclick = () => (window.location.href = prevUrl);
                } else {
                    prevButton.textContent = prevButton.defaultText;
                    prevButton.onclick = function (e) {
                        e.preventDefault();
                        tabs[activeIndex - 1].click();
                    };
                }

                // Link Button if the last tab is active, advance tabs if not
                if (activeTab === lastTab) {
                    nextButton.textContent = nextLabel;
                    // Check if the window path contains /forms/ and add a 'Submit' button
                    if (window.location.pathname.includes('/forms/')) {
                        // Hide the next button
                        nextButton.style.display = 'none';
                    } else {
                        nextButton.onclick = () => (window.location.href = nextUrl);
                    }
                } else {
                    // Hide the next button
                    nextButton.style.display = 'flex';
                    nextButton.textContent = nextButton.defaultText;
                    nextButton.onclick = function (e) {
                        e.preventDefault();
                        tabs[activeIndex + 1].click();
                    };
                }
            }

            // Bootstrap emits shown.bs.tab for both pointer/keyboard navigation and
            // programmatic tab changes. Validation opens the first section containing
            // an error without clicking its navigation button, so listening to the
            // completed tab-change event keeps Previous/Next in sync in every path.
            tabs.forEach((tab) => {
                tab.addEventListener('shown.bs.tab', updateButtonLinks);
            });

            updateButtonLinks(); // Initialize on page load
        });
    }

    // Check if the browser URL contains the 'registration' string in the query params
    const urlParams = new URLSearchParams(window.location.search);
    const registration = urlParams.get('registration');
    if (registration) {
        // Get the registration form
        const dealerCodeInput = document.getElementById('dealer_code');
        // Get the radio buttons
        const radioButtons = document.querySelectorAll(
            'input[name="user_type"]'
        );
        if (radioButtons) {
            // Loop through the radio buttons. If the value is 'dealer', add 'required' to the dealer code input, otherwise remove it
            radioButtons.forEach((radioButton) => {
                radioButton.addEventListener('change', function () {
                    if (this.value === 'dealer') {
                        dealerCodeInput.required = true;
                    } else {
                        dealerCodeInput.required = false;
                    }
                });
            });
        }
    }

    // If the user navigates to the /pre-registration/ page reset the "Apply Now" button href and text
    if (window.location.pathname.includes('/pre-registration/')) {
        const userType = getUserType();
        const operatorId = getOperatorId();
        const btnApplyNow = document.getElementById('button-apply-now');
        if (btnApplyNow && userType && operatorId) {
            const applyNowButtonAnchor = btnApplyNow.querySelector
                ? btnApplyNow.querySelector('a')
                : null;
            if (!applyNowButtonAnchor) return;
            applyNowButtonAnchor.href = `/forms/${userType}/?operator_id=${operatorId}`;
            applyNowButtonAnchor.textContent = 'Continue Application';
        }
    }

    // Check if the window path is for the application-start start page
    if (window.location.pathname.includes('/application-start/')) {
        // Get the user_type from the query params
        const userType = getUserType();
        // Get the operator_id from the query params
        const operatorId = getOperatorId();
        // Get the 'Apply Now' button and update the href with the user_type and operator_id
        const applyNowButtonContainer = document.getElementById(
            'btn-application-start'
        );
        if (applyNowButtonContainer) {
            const applyNowButton = applyNowButtonContainer.querySelector
                ? applyNowButtonContainer.querySelector('a')
                : null;
            if (!applyNowButton) return;
            applyNowButton.href = `/forms/${userType}/?operator_id=${operatorId}`;
            // Get the form_id from the localStorage userData index
            // this function is from user-functions.js
            const formId = getLocalStorageDataKey('userData', 'form_id'); // eslint-disable-line no-undef
            // If the form_id exists, update the button text with to read "Continue Application"
            if (formId) {
                applyNowButton.textContent = 'Continue Application';
            }
        }
    }

    // Check if the window path is for the application-complete page
    if (window.location.pathname.includes('/application-complete/')) {
        // Get the user_type from the query params
        const userType = getUserType();
        // Get the operator_id from the query params
        const operatorId = getOperatorId();
        // Get the 'Apply Now' button and update the href with the user_type and operator_id
        const printButton = document.getElementById('print-applicant-form');
        if (printButton) {
            printButton.addEventListener('click', () => {
                window.location.href = `/forms/${userType}-review/?operator_id=${operatorId}`;
            });
        }
    }

    //Splide carousel element, some accessibility attribute adjustments
    if (document.querySelectorAll('.splide').length > 0){
        document.querySelectorAll('.splide').forEach((splide) => {
            //Remove unneeded role from ul
            if (splide.querySelector('.splide__list').hasAttribute('role')){
                splide.querySelector('.splide__list').removeAttribute('role');
            }

            //Remove unneeded role from all inner li's
            splide.querySelectorAll('.splide__list li').forEach((splide_li) => {
                if (splide_li.hasAttribute('role')) {
                    splide_li.removeAttribute('role');
                }
            });
        });
    }

});
